import React from "react";
import { Button } from "../../components";
import ContentWrapper from "../../components/layout/ContentWrapper";
import { useCustomTranslation } from "../../helpers/translateHelpers";
import { Trans } from "react-i18next";
import InviteHeading from "./components/InviteHeading";
import { useNavigate } from "react-router";

const InvitePage: React.FC = (): React.ReactElement => {
  const { tInvite } = useCustomTranslation();
  const navigate = useNavigate();

  return (
    <ContentWrapper largePadding htmlTitle={tInvite("html_title")}>
      <InviteHeading />
      <div className="pt-2 pb-4">
        <p className="mb-2">{tInvite("create_account")}</p>
        <Button
          label={tInvite("create_account_button")}
          mode="primary"
          icon="arrow-right"
          onClick={() => navigate("register")}
        />
      </div>
      <hr className="border-gray bg-gray my-4" />
      <div>
        <p className="mb-2 pt-4">
          <Trans i18nKey="already_have_account" ns="customerportal-invite">
            Už máte účet u mwork365? Stačí se přihlásit. Pozvánku můžete
            přijmout již existujícím účtem
          </Trans>
        </p>
        <Button
          label={tInvite("login_button")}
          onClick={() => navigate("login")}
        />
      </div>
    </ContentWrapper>
  );
};

export default InvitePage;
